/**
 * @generated SignedSource<<17f67be62f75fc47d194da680b3178c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type usePublishReadEditorOnboardingStateFragment$data = {
  readonly key: string;
  readonly value: string | null | undefined;
  readonly " $fragmentType": "usePublishReadEditorOnboardingStateFragment";
};
export type usePublishReadEditorOnboardingStateFragment$key = {
  readonly " $data"?: usePublishReadEditorOnboardingStateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePublishReadEditorOnboardingStateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "usePublishReadEditorOnboardingStateFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "type": "OnboardingState"
};

(node as any).hash = "bc0f99d71f28b583e23f103ac8634d30";

export default node;
